import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Pagination from '@mui/material/Pagination';
import { SimpleTabs, TopNavigation, VolunteerSearcher } from '../../components';
import { NAVIGATION, TITLE, VOLUNTEERS } from '../../constants/navigation';
import { setPreviousPage } from '../../store/reducers/global';
import utils from '../../utils';
import { Box } from '@mui/material';
import { AuthenticationContext } from '../../hooks/global/AuthenticationContext';
import Authorization from '../Authorization';

const VolunteersList: React.FC = () => {
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [pagesTotal, setPagesTotal] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const { isAuthenticated } = useContext(AuthenticationContext);

  const onChangeSearchValue = (value: any) => {
    setSearchValue(value);
  };

  useEffect(() => {
    dispatch(
      setPreviousPage({
        previousPage: '/volunteers',
      })
    );
  }, []);

  return (
    <>
      {isAuthenticated ? (
        <>
          <TopNavigation volunteerFullName="" />
          <h1>{utils.searchByConstant(NAVIGATION, VOLUNTEERS, TITLE)}</h1>

          {/* TODO: Finish this feature before deploying */}
          {/* <h2>Социологический анализ</h2>
            <Statistics /> */}

          <h2>Поиск по анкетам</h2>
          <VolunteerSearcher onChangeSearchValue={onChangeSearchValue} />

          {/* TODO: вернуть сортировку после восстановления логики */}
          {/* <h2>Сортировка анкет</h2>
            <Sorter /> */}

          <h2>Список анкет</h2>
          <SimpleTabs
            searchValue={searchValue}
            setPagesTotal={setPagesTotal}
            pageNumber={pageNumber}
          />
          {Boolean(pagesTotal) && pagesTotal > 1 && (
            <Box mt={3} mb={2} display="flex" justifyContent="center">
              <Pagination
                count={pagesTotal}
                color="primary"
                size="large"
                onChange={(event, page) => setPageNumber(page)}
              />
            </Box>
          )}
        </>
      ) : (
        <Authorization />
      )}
    </>
  );
};

export default VolunteersList;
